export const course = 'api/Course';
export const integrityCourse = 'api/Integrity/GetIntegrityCourse';
export const lookupCourse = 'api/Course/LoadLookupCourse';
export const validCourses = 'api/Course/CoursesByProfile';
export const cloneCourse = 'api/Course/CloneCourse';
export const courseById = 'api/Course/GetCourseById';
export const postValidCourses = 'api/Course/CreatingRequirementsForAProfile';

export const courseType = 'api/CourseType';

export const shift = 'api/Turn';
export const integrityShift = 'api/Integrity/GetIntegrityTurns';
export const lookupShift = 'api/Turn/LoadLookupShifts';

export const profile = 'api/Profile';
export const integrityProfile = 'api/Integrity/GetIntegrityProfile';
export const lookupProfiles = 'api/Profile/LoadLookupProfiles';

export const sector = 'api/Sector';
export const sectorsByCourse = 'api/Sector/GetSectorsByCourse';
export const integritySector = 'api/Integrity/GetIntegritySector';
export const lookupSectors = 'api/Sector/LoadLookupSectors';

export const collaborator = 'api/Collaborator';
export const assistants = 'api/Collaborator/GetAssistantsFromCourse';
export const integrityCollaborator = 'api/Integrity/GetIntegrityCollaborator';
export const lookupCollaborator = 'api/Collaborator/LoadLookupCollaborator';
export const collaboratorFiltered =
  'api/Collaborator/CollaboratorFilteredBySector';

export const spac = 'api/Spac';
export const integritySpac = 'api/Integrity/GetIntegritySpac';
export const lookupSpac = 'api/Spac/LoadLookupSPAC';

export const stage = 'api/Stage';
export const createOnlineAutomatically = 'api/Stage/createOnlineAutomatically';
export const integrityInstance = 'api/Integrity/GetIntegrityInstance';

export const profSpac = 'api/ProfSpac';
export const integrityProfSpac = 'api/Integrity/GetIntegrityProfSpac';
export const lookupProfSpac = 'api/ProfSpac/LoadLookupProfSpac';
export const getNonDeletedProfSpac = 'api/ProfSpac/GetProfNoDeletedProfiles';
export const getProfNoDeletedProfSpacsForProfGralGrid =
  'api/ProfSpac/GetProfNoDeletedProfilesForProfGralGrid';

export const profGral = 'api/ProfGral';
export const profGralSpac = 'api/ProfGral/GetProfGralSpac';
export const integrityProfGral = 'api/Integrity/GetIntegrityProfGral';
export const lookupProfGral = 'api/ProfGral/LoadLookupProfGral';
export const integrityProfGralSpac = 'api/Integrity/GetIntegrityProfGralSpac';

export const profCourse = 'api/ProfCourse';
export const getProfCourseFromCourse = 'api/ProfCourse/getProfCourseFromCourse';
export const integrityProfCourse = 'api/Integrity/GetIntegrityProfCourse';
export const addProfSpacValidCourses =
  'api/ProfCourse/AddProfCourseToAValidCourse';

export const profCollaborator = 'api/ProfCollaborator';
export const integrityProfCollaborator =
  'api/Integrity/GetIntegrityProfCollaborator';

export const attendedWithCourse = 'api/AttendedJoinedWCourse';
export const activity = 'api/AttendedJoinedWCourse/Activity';
export const dashboard = 'api/AttendedJoinedWCourse/Dashboard';
export const attended = 'api/Attended';
export const courseStats = 'api/Course/CourseStats';

export const requirement = 'api/Requirement';
export const getRequirementsFromCourse =
  'api/Requirement/getRequirementsFromCourse';
export const integrityRequirement = 'api/Integrity/GetIntegrityRequirement';

export const content = 'api/Content';
export const integrityContent = 'api/Integrity/GetIntegrityContent';

export const choice = 'api/Choice';
export const choiceById = 'api/Choice/GetChoiceById';
export const integrityChoice = 'api/Integrity/GetIntegrityChoice';

export const answer = 'api/Answer';

export const settings = 'api/Settings';
export const integritySettings = 'api/Integrity/GetIntegritySettings';

export const allCourseTypes = 'api/CourseType/GetAllCourseType';
export const allSectors = 'api/Sector/GetAllSectors';
export const collabsFilteredBySectors =
  'api/Collaborator/GetCollabsFilteredBySectors';
export const KPIGraphics = 'api/Consult/GetKPIs';
export const KPIGrid = 'api/Consult/GetKPIDataGrid';
export const ReasonGraphics = 'api/Consult/GetLateReasonPiechart';
export const CollabGraphics = 'api/Consult/GetInstancesForCollaborators';
export const SectorGraphics = 'api/Consult/GetInstancesForSectors';
export const MonthlyGraphics = 'api/Consult/GetMonthlyInstances';

export const SectorReport = 'api/Report/DownloadSectorReport';
export const UserReport = 'api/Report/DownloadUserReport';
export const MonthlyReport = 'api/Report/DownloadMonthlyReport';
export const KPIReport = 'api/Report/DownloadKPIReport';
export const LateReasonReport = 'api/Report/DownloadLateReasonReport';

export const pendingCourse = 'api/AttendedJoinedWCourse/PendingCourse';
